import { Box, Typography } from '@material-ui/core';
import styled from 'styled-components';

export const Wrapper = styled(Box)`
  ${({ theme, width }) => `
    width: ${width ? '80%' : '100%'};
    background: #FAFAFA;
    margin: auto;
    border-radius: ${theme.shape.borderRadius};
    padding: 6% 4%;
    display: flex;
    align-items: center;
    justify-content: ${width ? 'space-between' : 'center'};
    padding-left : ${width ? 0 : '4%'};
    margin-left: ${!width ? 0 : 'auto'};
    margin-right : ${width ? "1rem" : 0};
    ${theme.breakpoints.down('lg')} {
      img {
        width: 30px;
      }
    }
  `}
`;

export const Image = styled.img`
  max-height: 43px;
  max-width: 40px;
  border-radius: 50%;
  display: block;
  margin: auto 0;
  margin-right: 7%;
`;

export const NameDiv = styled(Box)`
  ${({ width, theme }) => `
  margin-right: 1rem;
  display: ${width ? 'block' : 'none'};
  @media (max-width: 960px){
    display: none;
  }
  `}
`;

export const RightIcon = styled.img`
  ${({width, theme}) => `
    display: ${width ? 'block' : 'none'};
    width: 10px;
  `}
`;

export const Name = styled(Typography)`
  ${({ theme }) => `
    color: ${theme.palette.dark.main};
    font-weight: 600;
    ${theme.mixins.makeResponsive({ theme, fontSize: 16 })};
  `}
`;

export const Action = styled(Typography)`
  ${({ theme }) => `
    color: ${theme.palette.secondary.main};
    font-weight: 400;
    ${theme.mixins.makeResponsive({ theme, fontSize: 14 })};
  `}
`;
